import { SVGProps } from 'react';

const SvgUserDoctor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M280 304c2.7 0 5.3.1 8 .2V362c-27.6 7.1-48 32.2-48 62v40c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-24c0-17.7 14.3-32 32-32s32 14.3 32 32v24c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-40c0-29.8-20.4-54.9-48-62v-53.2C393.5 326.7 448 393 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-79 54.5-145.3 128-163.2v61.5c-23.1 6.9-40 28.3-40 53.7 0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7v-66.1c2.7-.1 5.3-.2 8-.2h112zm-136 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
      className="user-doctor_svg__fa-primary"
    />
    <path
      d="M352 128a128 128 0 1 1-256 0 128 128 0 1 1 256 0z"
      style={{
        opacity: 0.4,
      }}
    />
  </svg>
);
export default SvgUserDoctor;
